import Vue from 'vue'

export default {
  getDiscounts() {
    return Vue.http.get('discounts').then(res => res.body)
  },
  updateDiscount(id, data) {
    return Vue.http.put(`discounts/${id}`, data).then(res => res.body)
  },
  createDiscount(data) {
    return Vue.http.post('discounts', data).then(res => res.body)
  },
  getDiscountById(id) {
    return Vue.http.get(`discounts/${id}`).then(res => res.body)
  },
  updateOrder(data) {
    return Vue.http.put(`discounts/order`, data)
  }
}
